import { type FunctionComponent } from 'react';
import { NavLink, type LinkProps as NavLinkProps } from 'react-router-dom';
import { Link, type LinkProps } from '../Link/Link';

export type RouterLinkProps = LinkProps & Omit<NavLinkProps, keyof LinkProps>;

export const RouterLink: FunctionComponent<RouterLinkProps> = ({
  children,
  discover,
  prefetch,
  preventScrollReset,
  relative,
  reloadDocument,
  replace,
  state,
  to,
  viewTransition,
  ...props
}) => {
  return (
    <Link asChild {...props}>
      <NavLink
        discover={discover}
        prefetch={prefetch}
        preventScrollReset={preventScrollReset}
        relative={relative}
        reloadDocument={reloadDocument}
        replace={replace}
        state={state as unknown}
        to={to}
        viewTransition={viewTransition}
      >
        {children}
      </NavLink>
    </Link>
  );
};
